import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAPI } from '../../services/api';

const AdminLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await adminAPI.login(form);
      localStorage.setItem('adminToken', res.data.token);
      navigate('/nz-admin-2847/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f0f0f' }}>
      <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: 12, padding: '40px', width: '100%', maxWidth: 400 }}>
        <h2 style={{ color: '#fff', marginBottom: 8, fontSize: 22 }}>Nuzlio Admin</h2>
        <p style={{ color: '#666', marginBottom: 32, fontSize: 14 }}>Restricted access</p>
        <form onSubmit={handleSubmit}>
          <input type="email" placeholder="Admin email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required
            style={{ width: '100%', padding: '12px 16px', background: '#111', border: '1px solid #333', borderRadius: 8, color: '#fff', fontSize: 14, boxSizing: 'border-box', marginBottom: 16 }} />
          <input type="password" placeholder="Password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required
            style={{ width: '100%', padding: '12px 16px', background: '#111', border: '1px solid #333', borderRadius: 8, color: '#fff', fontSize: 14, boxSizing: 'border-box', marginBottom: 16 }} />
          {error && <p style={{ color: '#ff4444', fontSize: 13, marginBottom: 12 }}>{error}</p>}
          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '12px', background: '#6C63FF', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};
export default AdminLogin;
